<!------------------------------------------------------------------------------
 File: BookmarksNavigation 
 Created by Keni Williams <kenneth.williams@estuk.co.uk>.
 with: IntelliJ IDEA
 Date: 12/10/2018
 Time: 13:49
------------------------------------------------------------------------------->
<template>
    <div>
        <div id="bookmarks_navigation--wrapper-hr"
             class="hr-sect cursor-pointer"
             :class="{
                'text-accent-no':edit_enable == true
             }"
             v-on:click="edit_enable = !edit_enable"
        >Bookmarks
        </div>
        <ul class="collapsible collapsible-accordion">
            <!--add the last event link-->
            <li v-if="items.hasOwnProperty('last_event')">
                <a :title="'Last event: '+items.last_event.title"
                   data-toggle="tooltip"
                   :href="route(items.last_event)"
                   class="w-100 d-flex align-items-center collapsible-header"
                > <i class="favorite material-icons mr-1">trending_up</i>
                    <span class="text-truncate">{{items.last_event.title}}</span>
                </a>
            </li>
            <!--:href="route(item.route)"-->

            <template v-if="items.hasOwnProperty('list')">
                <template v-for="item in items.list">
                    <li v-if="(item.hasOwnProperty('route') && item.hasOwnProperty('bookmark') )">
                        <a  v-if="edit_enable != true"
                            :title="item.route.title"
                            :href="route(item.route)"
                            data-toggle="tooltip"
                            class="w-100 d-flex align-items-center collapsible-header"
                        >
                            <i
                                class="favorite material-icons mr-2"
                            >favorite_border</i>
                            <span class="text-truncate">{{item.route.title}}</span>
                        </a>
                        <a v-else
                           v-on:click="removeItem(item)"
                           :title="item.route.title"
                           data-toggle="tooltip"
                           class="w-100 d-flex align-items-center collapsible-header"
                        >
                            <i class="material-icons mr-2"
                            >delete</i>
                            <span class="text-truncate">{{item.route.title}}</span>
                        </a>
                    </li>
                    <li v-else>
                        {{item.route.title}}
                    </li>
                </template>
            </template>
        </ul>
    </div>
</template>

<script>
    import {replaceKeysWithParams} from "../../../../../app/Shared/Resources/Assets/js/helpers/routes";
    import {BOOKMARKS_COMMUNICATIONS} from "../../config";

    export default {
        name: "bookmarks_navigation",
        components: {},
        props: [
            'bookmarks_navigation_url',
            'bookmarks_navigation_delete_url',
            'current_list',
            'client_slug',
            'reload'
        ],
        created() {
        },
        destroyed() {
        },
        mounted() {
            this.items = JSON.parse(this.current_list);

            this.$nextTick(function () {
                BOOKMARKS_COMMUNICATIONS.$on('reload', () => {
                    this.update();
                });
            })
        },
        data() {
            return {
                edit_enable: false,
                /**
                 * @param   {String}    items.list[].route.route_name    the route name
                 * @param   {Object}    items.list[].route               the route data
                 * @param   {Object}    items.list[]               the route data
                 * @param   {Object}    items.last_event.route               the route data
                 * @var     {Array}[]   items                       the items
                 */
                items: []
            }
        },
        methods: {
            debug(args) {
                console.log(args);
            },
            route(item) {
//                 console.log('route', 'item', item);
                let uri_pattern = item.pattern,
                    keys = item.keys,
                    params = item.params;
//                console.log('route', 'uri_pattern',uri_pattern);
//                return '/';
                return '/' + replaceKeysWithParams(uri_pattern, keys, params);
                // console.log('route',test, 'uri_pattern',uri_pattern,keys,params);
            },
            update() {
                // console.log('update', 'this.bookmarks_navigation_url', this.bookmarks_navigation_url);
                if (this.bookmarks_navigation_url == null || '') {
                    return;
                }
                let _this = this,
                    data = {};

                axios.post(this.bookmarks_navigation_url, data)
                    .then(function (
                        /**
                         * @var   {Array} response.bookmarks
                         * @param {Object} response
                         */
                        response) {
                        if (response.data.success) {
                            _this.items = response.data.bookmarks;
                            // _this.$set('items', response.data.bookmarks);

                            // console.log('', 'response.data.bookmarks', response.data.bookmarks);

                        }
                    })
                    .catch(function () {

                    });
            },
            removeItem(item) {
                console.log('delete', 'item', item);
//
                $('[data-toggle="tooltip"]').tooltip('hide');
                let _this = this,
                    data = {
                        title: item.route.title
                    };

                axios.post(this.bookmarks_navigation_delete_url, data)
                    .then(function (response) {
                        if (response.data.success) {
                            _this.items = response.data.bookmarks;
                        }
                        // console.log('delete', 'response.data', response.data);
                        this.edit_enable = false;
                    })
                    .catch(function () {

                    });
            }
        },
        watch: {
            reload() {
                this.update();
            },
            current_list(obj) {
                console.log('current_list', 'prop updated', obj);
                this.items = obj;
            }
        },
        computed: {}
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/navigation/bookmarksNavigation.vue?6b056135